<template>
  <div class="">
    <Card>
      <Heading>Hur vill du se ut i quizzet?</Heading>
      <div class="controls">
        <div class="left-arrows">
          <div class="arrow" @click="head(currentHead - 1)">
            <img src="@/assets/images/arrow-left.png" />
          </div>
          <div
            :class="`arrow ${skinToneDisabled ? 'disabled' : ''}`"
            @click="tone(currentSkinTone - 1)"
          >
            <img src="@/assets/images/arrow-left.png" />
          </div>
          <div class="arrow" @click="body(currentBody - 1)">
            <img src="@/assets/images/arrow-left.png" />
          </div>
        </div>
        <div class="avatar-parts">
          <div class="head" :class="'head-' + currentHead">
            <img :src="avatarHead" />
          </div>
          <div class="body">
            <img :src="avatarBody" />
          </div>
        </div>
        <div class="right-arrows">
          <div class="arrow" @click="head(currentHead + 1)">
            <img src="@/assets/images/arrow-right.png" />
          </div>
          <div
            :class="`arrow ${skinToneDisabled ? 'disabled' : ''}`"
            @click="tone(currentSkinTone + 1)"
          >
            <img src="@/assets/images/arrow-right.png" />
          </div>
          <div class="arrow" @click="body(currentBody + 1)">
            <img src="@/assets/images/arrow-right.png" />
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import * as settings from '@/data/AvatarBuilder.json';
import Heading from '@/components/Heading';
import Card from '@/components/Card';
export default {
  components: {
    Card,
    Heading
  },
  data() {
    return {
      currentHead: 0,
      currentSkinTone: 0,
      currentBody: 0,
      skinToneDisabled: false
    };
  },
  computed: {
    avatarHead() {
      const head = settings.heads[this.currentHead];
      const tone =
        settings.heads[this.currentHead].skinTones.length > 0
          ? settings.heads[this.currentHead].skinTones[this.currentSkinTone]
          : -1;

      let filename = head.prefix;
      if (tone !== -1) {
        filename = head.prefix + 't' + tone;
      }

      return require(`../assets/images/avatars/${filename}.png`);
    },
    avatarBody() {
      const body = settings.bodies[this.currentBody];
      const filename = 'b' + body.index;
      return require(`../assets/images/avatars/${filename}.png`);
    }
  },
  watch: {
    currentHead(val) {
      sessionStorage.setItem('avatarHead', val);
      this.$emit('avatarChange', this.getAvatarFilename());
    },
    currentSkinTone(val) {
      sessionStorage.setItem('avatarSkinTone', val);
      this.$emit('avatarChange', this.getAvatarFilename());
    },
    currentBody(val) {
      sessionStorage.setItem('avatarBody', val);
      this.$emit('avatarChange', this.getAvatarFilename());
    }
  },
  created() {
    const sessionAvatarHead = sessionStorage.getItem('avatarHead');
    if (sessionAvatarHead) {
      this.currentHead = parseInt(sessionAvatarHead, 10);
    }
    const sessionAvatarSkinTone = sessionStorage.getItem('avatarSkinTone');
    if (sessionAvatarSkinTone) {
      this.currentSkinTone = parseInt(sessionAvatarSkinTone, 10);
    }
    const sessionAvatarBody = sessionStorage.getItem('avatarBody');
    if (sessionAvatarBody) {
      this.currentBody = parseInt(sessionAvatarBody, 10);
    }
  },
  mounted() {
    this.$emit('avatarChange', this.getAvatarFilename());
  },
  methods: {
    getAvatarFilename() {
      const head = settings.heads[this.currentHead];
      const tone =
        settings.heads[this.currentHead].skinTones.length > 0
          ? settings.heads[this.currentHead].skinTones[this.currentSkinTone]
          : -1;
      const body = settings.bodies[this.currentBody];

      if (tone !== -1) {
        return head.prefix + 'b' + body.index + 't' + tone + '.png';
      } else {
        return head.prefix + 'b' + body.index + '.png';
      }
    },
    head(requestedIndex) {
      if (requestedIndex < 0) {
        requestedIndex = settings.heads.length - 1;
      } else if (requestedIndex >= settings.heads.length) {
        requestedIndex = 0;
      }

      if (settings.heads[requestedIndex].skinTones.length === 0) {
        this.skinToneDisabled = true;
      } else {
        this.skinToneDisabled = false;
      }

      this.currentHead = requestedIndex;
    },
    tone(requestedIndex) {
      if (this.skinToneDisabled) {
        return;
      }
      if (requestedIndex < 0) {
        requestedIndex = settings.heads[this.currentHead].skinTones.length - 1;
      } else if (
        requestedIndex >= settings.heads[this.currentHead].skinTones.length
      ) {
        requestedIndex = 0;
      }
      this.currentSkinTone = requestedIndex;
    },
    body(requestedIndex) {
      if (requestedIndex < 0) {
        requestedIndex = settings.bodies.length - 1;
      } else if (requestedIndex >= settings.bodies.length) {
        requestedIndex = 0;
      }
      this.currentBody = requestedIndex;
    }
  }
};
</script>

<style lang="scss" scoped>
.controls {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  .arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    margin: 25px 0;
    border-radius: 50%;

    img {
      width: 12px;
    }
    &:active {
      background-color: $tap-highlight-color;
    }
    &.disabled {
      opacity: 0.2;
    }
  }
}
.avatar-parts {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 142px;

  .head {
    position: relative;
    bottom: -10px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    z-index: 2;
    height: 120px;
  }
  .body {
    position: relative;
    top: -10px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    z-index: 1;
  }
}
</style>
